import { applyMiddleware, compose, createStore } from 'redux';
import { thunk as thunkMiddleware } from 'redux-thunk';
import rootReducer from './store/reducers';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunkMiddleware)));

export default store;
